/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import { Typography2 } from '@coursera/cds-core';

import DomainIcon from 'bundles/unified-common/components/pill/DomainIcon';
import Pill from 'bundles/unified-common/components/pill/Pill';

import _t from 'i18n!nls/partners-graphql';

type Domain = {
  id: string;
  slug: string | null;
  name: string;
};

type Props = {
  domains: Domain[];
};

const styles = {
  section: css`
    margin-top: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-300);
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-150);
  `,
  pills: css`
    display: flex;
    gap: var(--cds-spacing-100);
    flex-wrap: nowrap;
  `,
  pill: css`
    white-space: nowrap;
  `,
};

const ExploreCategoriesSection = ({ domains }: Props) => {
  if (!domains?.length) {
    return null;
  }

  return (
    <div css={styles.section}>
      <Typography2 component="h2" variant="subtitleLarge">
        {_t('Explore categories')}
      </Typography2>
      <OverflowCarousel css={styles.pills} shouldAllowSpaceForHoverItems>
        {domains.map((domain) => (
          <Pill key={domain.id} href={`/browse/${domain.slug || domain.id}`} css={styles.pill}>
            <DomainIcon domain={{ id: domain.id, name: domain.name, slug: domain.slug || domain.id }} />
            {domain.name}
          </Pill>
        ))}
      </OverflowCarousel>
    </div>
  );
};

export default ExploreCategoriesSection;
